import 'core-js/stable'
import Vue from 'vue'
import App from './App'
import router from './router'
import CoreuiVue from '@coreui/vue'
import { iconsSet as icons } from './assets/icons/icons.js'
import store from './store'
import VueNumberInput from '@chenfengyuan/vue-number-input'

const VueMoment = require('vue-moment')
const VueCookie = require('vue-cookie')
import { dateFilter } from "vue-date-fns";

const moment = require('moment-timezone')
moment.tz.setDefault('America/Sao_Paulo')

Vue.filter("date", dateFilter);

Vue.config.performance = true
Vue.use(CoreuiVue)
Vue.use(VueMoment, {moment})
Vue.use(VueCookie)
Vue.use(VueNumberInput)
Vue.prototype.$log = console.log.bind(console)

new Vue({
  el: '#app',
  router,
  store,
  icons,
  template: '<App/>',
  components: {
    App
  },
  watch: {
    '$route': function(route) {
      let isAuthenticated = this.$store.state.session.token
      if (route.name !== 'Login' && ! isAuthenticated) {
        this.$router.push('/pages/login')
      }
    }
  }
})
